import { render, staticRenderFns } from "./StudentByImc.vue?vue&type=template&id=151cfb81&"
import script from "./StudentByImc.js?vue&type=script&lang=js&"
export * from "./StudentByImc.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports